<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>
          合作方式：
        </span>
        <el-select clearable v-model="search.partnershipType" placeholder="请选择合作方式">
          <el-option label="子公司" :value="1"></el-option>
          <el-option label="第三方" :value="2"></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0">
          合作方名称：
        </span>
        <el-input v-model="search.partnerName" placeholder="请输入合作方名称"></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <el-button type="primary" size="medium" @click="getList()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </el-col>
    </el-row>
    <div class="m-b-10">
      <el-button type="primary" size="medium" @click="dialogFormVisible = true">+&nbsp;创建合作方</el-button>
      <el-button :type="allSelectedIds.length ? 'primary' : 'info'" :disabled="allSelectedIds.length ? false : true"
                 size="medium" @click="batchDelete">批量删除
      </el-button>
    </div>
    <el-table ref="checktableData" :data="list" v-loading="listLoading" @selection-change="handleSelectionChange"
              :reserve-selection="true" height="60vh">
      <el-table-column type="selection" min-width="50" align="center">
      </el-table-column>
      <el-table-column label="合作编号" min-width="120" align="center">
        <template slot-scope="scope">{{ scope.row.partnershipId }}</template>
      </el-table-column>
      <el-table-column label="合作方式" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.partnershipTypeStr }}</template>
      </el-table-column>
      <el-table-column label="合作方名称" min-width="200" align="center">
        <template slot-scope="scope">{{ scope.row.partnerName }}</template>
      </el-table-column>
      <el-table-column label="联系方式" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.contactInfo }}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum"
                     :page-size="search.pageSize" :page-sizes="[10,20]" :total="total">
      </el-pagination>

    </div>
    <el-dialog v-if="dialogFormVisible" width="35%" class="dialog" title="创建合作方" :visible.sync="dialogFormVisible">
      <el-form ref="ruleForm" label-position="left" :rules="rules" :model="dialogForm" label-width="120px">
        <el-form-item label="合作方式：" prop="partnershipType">
          <el-radio-group v-model="dialogForm.partnershipType">
            <el-radio :label="1">子公司</el-radio>
            <el-radio :label="2">第三方</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="合作方名称：" prop="partnerName">
          <el-input v-model="dialogForm.partnerName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="合作方地址：" prop="address">
          <el-input v-model="dialogForm.address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" prop="contactInfo">
          <el-input v-model="dialogForm.contactInfo" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="addPartner('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'partnerManagement',
  data() {
    return {
      list: [],
      search: {
        partnershipType: "",
        partnerName: "",
        pageSize: 10,
        pageNum: 1,
      },
      listLoading: false,
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [],// 所有未选中的id
      total: 20,
      dialogFormVisible: false,
      dialogForm: {
        partnershipId: '',
        partnershipType: '',//合作方式 1 子公司 2 第三方
        partnerName: '',
        contactInfo: '',
        address: '',
      },
      rules: {
        partnershipType: [
          {required: true, message: '请选择合作方式', trigger: 'blur'},
        ],
        partnerName: [
          {required: true, message: '请填写合作方名称', trigger: 'blur'},
        ],
        address: [
          {required: true, message: '请填写合作方地址', trigger: 'blur'},
        ],
        contactInfo: [
          {required: true, message: '请填写联系方式', trigger: 'blur'},
        ],
      }
    }
  },
  methods: {
    handleSelectionChange(rows) {
      // console.log(rows);
      // this.allSelectedIds 所有页选中的数据
      // this.currentTableData  当前页所有的数据
      // selectedIds  选中的项
      // unSelectedIds  未选中的项
      const selectedIds = rows.map((item) => item.partnershipId);
      const unSelectedIds = this.list
        .map((item) => item.partnershipId)
        .filter((item) => !selectedIds.includes(item));
      // // 获的所有选中的项
      this.allSelectedIds = this.allSelectedIds.filter(
        (item) => !unSelectedIds.includes(item)
      );
      // // //获得未选中的项
      this.unSelectedIds = unSelectedIds
      // // 数组去重
      this.allSelectedIds = [
        ...new Set([...this.allSelectedIds, ...selectedIds]),
      ];
      console.log(this.allSelectedIds, "this.allSelectedIds")
    },
    getList() {
      let params = {
        pageSize: this.search.pageSize,
        pageNum: this.search.pageNum,
      }
      this.list = [];
      this.listLoading = true;
      const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/page'
      this.HttpService.post(url, Object.assign(this.paramsData(), params)).then(res => {
        if (res.statusCode === 200)
          this.total = res.data.total
        if (res.data.length === 0) {
          this.$dialog({
            title: '温馨提示',
            content: '未查询到结果!',
            footBtn: false,
            width: '20%',
            dialogType: 'sighicon',
          })
        } else {
          this.arr = [];
          this.list = res.data.records
          this.listLoading = false
        }
      })
    },
    paramsData() {
      let {partnerName, partnershipType} = this.search || ''
      let params = {
        partnerName: partnerName,
        partnershipType: partnershipType,
      }
      return params
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList()
    },
    handleCurrentChange() {
      // this.oldarr = this.oldarr.concat(this.unSelectedIds)
      // this.unSelectedIds = [...new Set(this.oldarr)]
      this.getList()
    },
    batchDelete() {
      this.$dialog({
        title: '温馨提示',
        content: '是否要删除，删除后不可以恢复！',
        cancel_buttton: '否',
        ok_buttton: '是',
        width: '400px',
        footBtn: 'card',
        dialogType: 'delete',
        onOk: () => {
          this.HttpService.delete(`/autoapp-recovery-server-auth/api/tbl-partner-management/delete?idList=${this.allSelectedIds}`,).then(res => {
            if (res.statusCode === 200)
              this.$message.success('删除成功')
              this.getList()
              this.allSelectedIds = []
              this.unSelectedIds = []

          })
        },
        onCancel: () => {
          console.log('cancel');
        }
      })
    },
    addPartner(formName) {
      let url = '/autoapp-recovery-server-auth/api/tbl-partner-management/save'
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.HttpService.post(url, this.dialogForm).then(res => {
            if (res.statusCode === 200)
              this.$message.success('操作成功')
            this.getList()
            this.closeDialog()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    goEdit(data) {
      Object.assign(this.dialogForm, data)
      this.dialogFormVisible = true
    },
    closeDialog() {
      this.dialogFormVisible = false
      this.dialogForm = this.$options.data().dialogForm
    },
    resetForm(formName) {
      this.search = this.$options.data().search
    },
  },
  mounted() {
  }
}
</script>


<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;

  span {
    min-width: 100px;
  }
}

.row-bg {
  margin-bottom: 15px;
}

.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/recoveryManagement/partnerManagement.vue